"use strict";

import Alert from "../../librairies/Alert";
import Localization from "../../librairies/Localization";

export default class MailingsList {
  constructor($mailingsList) {
    this.$mailingsList = $mailingsList;
    this.$paginationContainer = this.$mailingsList.querySelector("#pagination-container");
    this.$mailingsListHeader = this.$mailingsList.querySelector("#mailings-list-header");

    if (this.$paginationContainer) {
      this.$paginationContainer.addEventListener("click", e => {
        if (e.target.classList.contains("disabled")) {
          e.preventDefault();
        }
      });
    }

    if (this.$mailingsListHeader) {
      const filterForm = this.$mailingsListHeader.querySelector("form");

      filterForm.addEventListener("submit", e => {
        e.stopPropagation();
        e.preventDefault();

        const startDate = filterForm.querySelector("input#start").value;
        const endDate = filterForm.querySelector("input#end").value;

        if (startDate === '' || endDate === '') {
          Alert.error(Localization.Translate("Veuillez remplir les champs de date"));
        } else if (startDate > endDate) {
          Alert.error(Localization.Translate("La date de début doit être antérieure à la date de fin"));
        } else {
          this.$mailingsList.querySelector("div.alerts").innerHTML = "";
          filterForm.submit();
        }
      });
    }
  }
}
